import { InitialState } from "./type";

export const initialState: InitialState = {
  productList: [],
  productById: {},
  products: {},
  meta: {},
};
